import { Button } from "risa-oasis-ui_v2";
import { uploadGridClick } from "../actions";

const Header = () => {
  return (
    <div className="nar-configuration-layout__header flex w-full items-center justify-between">
      <div className="font-bold">NAR Config</div>
      <div>
        <Button
          disabled={false}
          onClick={uploadGridClick}
          buttonType="secondary"
          size="medium"
        >
          Upload Grid
        </Button>
      </div>
    </div>
  );
};

export default Header;
